import template from './planned-activities.html'

export let plannedActivities = {
	bindings: {
		parent  : '<',
		children: '<',
		activity: '=',
	},
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$stateParams', 'GlobalConfig', 'WorkPlanModalSrv', 'CssClasses', 'Validations', 'Setters', 
		'$cookies', 'Ramda', 'Util', 'GlobalSrv', '$rootScope',
		function plannedActivitiesCtrl ($stateParams, GlobalConfig, WorkPlanModalSrv, CssClasses, Validations, Setters, $cookies, Ramda, Util, GlobalSrv, $rootScope) {
			const textColor = CssClasses.textColor
			const icons = CssClasses.icons
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			let _entries = []

			//const calcHours = (arr, param) => arr.reduce((accumulator, current) => (accumulator + current[param]), 0)
			this.$onInit = () => {
				this.children.totalExecutedHours = calcHours(this.children, 'hoursExecuted')
				this.children.totalPlannedHours = calcHours(this.children, 'hoursPlanned')
			}

			angular.extend(this, {
				// variables
				get entries () {
					return _entries
				},
				set entries (value) {
					_entries = value

					return value
				},
				title                       : 'Actividades Planeadas ',
				contentHeaderCSS            : [ 'col-md-2', 'no-padding', 'font-normal', 'text-xs' ],
				headingCSS                  : [ 'col-md-2', 'no-padding', 'text-center', 'font-normal', 'text-xs' ],
				timeCSS                     : [ 'col-md-4', 'no-padding', 'text-center', textColor.blue, 'text-xs' ],
				contentCSS                  : [ 'col-md-2', 'no-padding', 'text-center', textColor.blue, 'text-xs' ],
				acctionCCS                  : [ 'col-md-2', 'no-padding', 'text-center', 'text-gris-dark', 'text-sm' ],
				showTime                    : (activity) => activity.timeRangeTypeId === 1 ? (activity.periodName || activity.periodicityName) : activityDates(activity),
				edit                        : icons.edit,
				add                         : icons.add,
				isProjectsType              : Validations.isProjectsType(this.parent),
				isActivitiesType            : Validations.isActivitiesType(this.parent),
				inExecution                 : Validations.inExecution(currentStage),
				inEvaluation                : Validations.inEvaluation(currentStage),
				inReviewExecution           : Validations.inReviewExecution(currentStage),
				isProductsType              : Validations.isProductsType(this.parent),
				isExtensionProjectsType     : Validations.isExtensionProjectsType(this.parent),
				isCrossExtensionProjectsType: Validations.isCrossExtensionProjectsType(this.parent),
				// methods
				setActivity                 : setActivity,
				addActivity                 : addActivity,
				executionEntries            : executionEntries,
				isDisabled                  : isDisabled,
				inHistory                   : $stateParams.inHistory,
				isShowAction                : isShowAction,
			})

			function calcHours(arr, param) {
				return arr.reduce((accumulator, current) => (accumulator + current[param]), 0)
			}

			function activityDates (activity) {
				return Util.setDate(activity.startDate) + ' - ' + Util.setDate(activity.endDate)
			}

			function executionEntries (parent, children) {
				let parentActivity = children

				parentActivity.selectedActivityId = children.workplanTeacherActivityId
				parentActivity.asignatureName = children.name
				WorkPlanModalSrv.setVariable(parentActivity)
				WorkPlanModalSrv.executionEntries()
			}

			function setActivity (parent, order, child = {}) {
				switch (order) {

				case 'ADD':
					WorkPlanModalSrv.setVariable({ children: child, action: 'ADD' })
					WorkPlanModalSrv.registerExecution().then((promise) => {
						let data = WorkPlanModalSrv.getVariable()

						// console.log(data, promise)
						// if (data) this.children.totalExecutedHours = calcHours(this.children, 'hoursExecuted')
						if (data) {
							let index = this.children.findIndex(children => {
								return children.workplanTeacherActivityId == data.idActivity2
							})

							if (!this.children[index].hoursExecuted) this.children[index].hoursExecuted = 0

							{ this.children[index].hoursExecuted += data.hoursExecuted
								this.children.totalExecutedHours += data.hoursExecuted
								GlobalSrv.notify($rootScope, 'hoursChanged', this.children.totalExecutedHours)
							}
							this.activity.totalHoursExecuted += data.hoursExecuted
							$rootScope.$emit('rootScope:execHours', 'execHours!')
						}
					})
					break
				case 'EDIT':
					let diffHours = this.children.totalExecutedHours

					WorkPlanModalSrv.editChildrenExecution({ children: child }).then((promise) => {
						this.children.totalExecutedHours = calcHours(this.children, 'hoursExecuted')
						GlobalSrv.notify($rootScope, 'hoursChanged', this.children.totalExecutedHours)
						diffHours = this.children.totalExecutedHours - diffHours
						this.activity.totalHoursExecuted += diffHours
						$rootScope.$emit('rootScope:execHours', 'execHours!')
					})
					break
      
				}
			}

			function addActivity (parent) {
				WorkPlanModalSrv.setVariable([ parent ])
				WorkPlanModalSrv.addActivity('custom').then((promise) => {
					let data = WorkPlanModalSrv.getVariable()

					if (data) this.children.push(data)
				})
			}

			function isDisabled (activity) { 
				if (this.parent.executionFinish || this.parent.isBlocked) {
					return 'disabled'
				} else if (activity.hoursExecuted < 0) {
					return 'disabled'
				}
			}

			function isShowAction() {
				if (this.isProductsType || this.isProjectsType
        || this.isExtensionProjectsType || this.isCrossExtensionProjectsType) {
					return this.parent.hoursChildren
				}
			}
		},
	] }


// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/planned-activities.js